<script setup lang="ts">
import { inject } from 'vue';
import type { ComputedRef } from 'vue';
import { useRouter } from 'vue-router';
import ProfileChildSettingList from 'modules/Setting/components/ProfileChildSettingList/ProfileChildSettingList.vue';
import BCard from 'src/shared/components/base/BCard/BCard.vue';
import BErrorBanner from 'src/shared/components/base/BErrorBanner/BErrorBanner.vue';
import { useCurrentUser } from 'shared/composables/useCurrentUser';

const currentUserId = inject('currentUserId') as ComputedRef<number>;
const currentUser = useCurrentUser(currentUserId.value, 'all');

const router = useRouter();

// defineEmits<{
//   // (event: 'update:moduleValue', payload: string): void
// }>()
</script>

<template>
  <BCard
    v-if="currentUser?.role?.type === 'child'"
    size="sm"
    class="rounded-borders-xl shadow-card"
  >
    <q-card-section v-if="currentUser">
      <ProfileChildSettingList :current-user="currentUser" />
    </q-card-section>
    <q-card-section v-else>
      <BErrorBanner @ok="router.push({ name: 'dashboard' })">
        {{ $t('UNFORTUNATLY_WE_COULD_NOT_LOAD_THE_USER_DATA') }}
      </BErrorBanner>
    </q-card-section>
  </BCard>
</template>
